module.exports = __webpack_public_path__ + "img/anti-cheating-250.cc3b6ee0.png";